import { default as delete_45accountkhsOawvHkIMeta } from "/opt/render/project/src/.app/pages/auth/delete-account.vue?macro=true";
import { default as login5o6afqXVStMeta } from "/opt/render/project/src/.app/pages/auth/login.vue?macro=true";
import { default as recoverI8WJ7WZAF1Meta } from "/opt/render/project/src/.app/pages/auth/recover.vue?macro=true";
import { default as register0M6hx7DxadMeta } from "/opt/render/project/src/.app/pages/auth/register.vue?macro=true";
import { default as resetBU3Ton4EKKMeta } from "/opt/render/project/src/.app/pages/auth/reset.vue?macro=true";
import { default as indexqPlZP6X4DlMeta } from "/opt/render/project/src/.app/pages/index.vue?macro=true";
import { default as indexNYrLTUUQQPMeta } from "/opt/render/project/src/.app/pages/manage/categories/index.vue?macro=true";
import { default as subLUDg35zOCRMeta } from "/opt/render/project/src/.app/pages/manage/categories/sub.vue?macro=true";
import { default as follow_45up_45categoriesFosTD88yaRMeta } from "/opt/render/project/src/.app/pages/manage/follow-up-categories.vue?macro=true";
import { default as assetsuLnp4WOvlcMeta } from "/opt/render/project/src/.app/pages/manage/groups/[id]/assets.vue?macro=true";
import { default as channelss8ElkWDXErMeta } from "/opt/render/project/src/.app/pages/manage/groups/[id]/channels.vue?macro=true";
import { default as indexxueEGKzTY2Meta } from "/opt/render/project/src/.app/pages/manage/groups/[id]/index.vue?macro=true";
import { default as membersVpsId527qjMeta } from "/opt/render/project/src/.app/pages/manage/groups/[id]/members.vue?macro=true";
import { default as indexNHnzBQY0IQMeta } from "/opt/render/project/src/.app/pages/manage/groups/index.vue?macro=true";
import { default as my_45groupsa2ppBPeOPiMeta } from "/opt/render/project/src/.app/pages/manage/groups/my-groups.vue?macro=true";
import { default as iconsZDvm45Ar6sMeta } from "/opt/render/project/src/.app/pages/manage/icons.vue?macro=true";
import { default as active0AYxcTBfbEMeta } from "/opt/render/project/src/.app/pages/manage/incidents/active.vue?macro=true";
import { default as editorobgDAN1pymMeta } from "/opt/render/project/src/.app/pages/manage/incidents/editor.vue?macro=true";
import { default as galleryBtWTLcwFAOMeta } from "/opt/render/project/src/.app/pages/manage/incidents/gallery.vue?macro=true";
import { default as indexevJYvRMQ7vMeta } from "/opt/render/project/src/.app/pages/manage/incidents/index.vue?macro=true";
import { default as table7oe8sToq9oMeta } from "/opt/render/project/src/.app/pages/manage/incidents/table.vue?macro=true";
import { default as types9q9DeN1j0ZMeta } from "/opt/render/project/src/.app/pages/manage/incidents/types.vue?macro=true";
import { default as indexosNFIZquRCMeta } from "/opt/render/project/src/.app/pages/manage/index.vue?macro=true";
import { default as info_45sourcesSf74wI213uMeta } from "/opt/render/project/src/.app/pages/manage/info-sources.vue?macro=true";
import { default as notifications1HLlWO8ZbcMeta } from "/opt/render/project/src/.app/pages/manage/notifications.vue?macro=true";
import { default as contactsCdbublCqGcMeta } from "/opt/render/project/src/.app/pages/manage/profile/contacts.vue?macro=true";
import { default as indexa4smCGMYTEMeta } from "/opt/render/project/src/.app/pages/manage/profile/index.vue?macro=true";
import { default as password2accOA8CBWMeta } from "/opt/render/project/src/.app/pages/manage/profile/password.vue?macro=true";
import { default as profileFecxDTwiSUMeta } from "/opt/render/project/src/.app/pages/manage/profile.vue?macro=true";
import { default as recommendationstg0YQbEzCCMeta } from "/opt/render/project/src/.app/pages/manage/recommendations.vue?macro=true";
import { default as choroplethLR9JREXYnxMeta } from "/opt/render/project/src/.app/pages/manage/reports/choropleth.vue?macro=true";
import { default as indexm0MkOJz2phMeta } from "/opt/render/project/src/.app/pages/manage/reports/index.vue?macro=true";
import { default as risk_45levelsIzjNAjemhVMeta } from "/opt/render/project/src/.app/pages/manage/risk-levels.vue?macro=true";
import { default as safe_45zonesoCJsQIyJX8Meta } from "/opt/render/project/src/.app/pages/manage/safe-zones.vue?macro=true";
import { default as approvalsoh0twZcmC3Meta } from "/opt/render/project/src/.app/pages/manage/users/approvals.vue?macro=true";
import { default as indexJ8gcVlLFa3Meta } from "/opt/render/project/src/.app/pages/manage/users/index.vue?macro=true";
import { default as zonesGLWhgLKxLMMeta } from "/opt/render/project/src/.app/pages/manage/zones.vue?macro=true";
import { default as copyrightqYyMdXXjAfMeta } from "/opt/render/project/src/.app/pages/policies/copyright.vue?macro=true";
import { default as eulaidVSJvoPg7Meta } from "/opt/render/project/src/.app/pages/policies/eula.vue?macro=true";
import { default as privacyWXXRWDW3IQMeta } from "/opt/render/project/src/.app/pages/policies/privacy.vue?macro=true";
import { default as supportDh4TcyxSSFMeta } from "/opt/render/project/src/.app/pages/policies/support.vue?macro=true";
import { default as unauthorizedN63AC73v5SMeta } from "/opt/render/project/src/.app/pages/unauthorized.vue?macro=true";
export default [
  {
    name: "auth-delete-account",
    path: "/auth/delete-account",
    meta: delete_45accountkhsOawvHkIMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/auth/delete-account.vue").then(m => m.default || m)
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: login5o6afqXVStMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: "auth-recover",
    path: "/auth/recover",
    meta: recoverI8WJ7WZAF1Meta || {},
    component: () => import("/opt/render/project/src/.app/pages/auth/recover.vue").then(m => m.default || m)
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: register0M6hx7DxadMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: "auth-reset",
    path: "/auth/reset",
    meta: resetBU3Ton4EKKMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/auth/reset.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexqPlZP6X4DlMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-categories",
    path: "/manage/categories",
    meta: indexNYrLTUUQQPMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/categories/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-categories-sub",
    path: "/manage/categories/sub",
    meta: subLUDg35zOCRMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/categories/sub.vue").then(m => m.default || m)
  },
  {
    name: "manage-follow-up-categories",
    path: "/manage/follow-up-categories",
    meta: follow_45up_45categoriesFosTD88yaRMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/follow-up-categories.vue").then(m => m.default || m)
  },
  {
    name: "manage-groups-id-assets",
    path: "/manage/groups/:id()/assets",
    meta: assetsuLnp4WOvlcMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/groups/[id]/assets.vue").then(m => m.default || m)
  },
  {
    name: "manage-groups-id-channels",
    path: "/manage/groups/:id()/channels",
    meta: channelss8ElkWDXErMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/groups/[id]/channels.vue").then(m => m.default || m)
  },
  {
    name: "manage-groups-id",
    path: "/manage/groups/:id()",
    meta: indexxueEGKzTY2Meta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/groups/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-groups-id-members",
    path: "/manage/groups/:id()/members",
    meta: membersVpsId527qjMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/groups/[id]/members.vue").then(m => m.default || m)
  },
  {
    name: "manage-groups",
    path: "/manage/groups",
    meta: indexNHnzBQY0IQMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/groups/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-groups-my-groups",
    path: "/manage/groups/my-groups",
    meta: my_45groupsa2ppBPeOPiMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/groups/my-groups.vue").then(m => m.default || m)
  },
  {
    name: "manage-icons",
    path: "/manage/icons",
    meta: iconsZDvm45Ar6sMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/icons.vue").then(m => m.default || m)
  },
  {
    name: "manage-incidents-active",
    path: "/manage/incidents/active",
    component: () => import("/opt/render/project/src/.app/pages/manage/incidents/active.vue").then(m => m.default || m)
  },
  {
    name: "manage-incidents-editor",
    path: "/manage/incidents/editor",
    meta: editorobgDAN1pymMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/incidents/editor.vue").then(m => m.default || m)
  },
  {
    name: "manage-incidents-gallery",
    path: "/manage/incidents/gallery",
    meta: galleryBtWTLcwFAOMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/incidents/gallery.vue").then(m => m.default || m)
  },
  {
    name: "manage-incidents",
    path: "/manage/incidents",
    meta: indexevJYvRMQ7vMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/incidents/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-incidents-table",
    path: "/manage/incidents/table",
    meta: table7oe8sToq9oMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/incidents/table.vue").then(m => m.default || m)
  },
  {
    name: "manage-incidents-types",
    path: "/manage/incidents/types",
    meta: types9q9DeN1j0ZMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/incidents/types.vue").then(m => m.default || m)
  },
  {
    name: "manage",
    path: "/manage",
    meta: indexosNFIZquRCMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-info-sources",
    path: "/manage/info-sources",
    meta: info_45sourcesSf74wI213uMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/info-sources.vue").then(m => m.default || m)
  },
  {
    name: "manage-notifications",
    path: "/manage/notifications",
    meta: notifications1HLlWO8ZbcMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/notifications.vue").then(m => m.default || m)
  },
  {
    name: profileFecxDTwiSUMeta?.name,
    path: "/manage/profile",
    meta: profileFecxDTwiSUMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/profile.vue").then(m => m.default || m),
    children: [
  {
    name: "manage-profile-contacts",
    path: "contacts",
    meta: contactsCdbublCqGcMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/profile/contacts.vue").then(m => m.default || m)
  },
  {
    name: "manage-profile",
    path: "",
    meta: indexa4smCGMYTEMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-profile-password",
    path: "password",
    meta: password2accOA8CBWMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/profile/password.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "manage-recommendations",
    path: "/manage/recommendations",
    meta: recommendationstg0YQbEzCCMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/recommendations.vue").then(m => m.default || m)
  },
  {
    name: "manage-reports-choropleth",
    path: "/manage/reports/choropleth",
    meta: choroplethLR9JREXYnxMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/reports/choropleth.vue").then(m => m.default || m)
  },
  {
    name: "manage-reports",
    path: "/manage/reports",
    meta: indexm0MkOJz2phMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/reports/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-risk-levels",
    path: "/manage/risk-levels",
    meta: risk_45levelsIzjNAjemhVMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/risk-levels.vue").then(m => m.default || m)
  },
  {
    name: "manage-safe-zones",
    path: "/manage/safe-zones",
    meta: safe_45zonesoCJsQIyJX8Meta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/safe-zones.vue").then(m => m.default || m)
  },
  {
    name: "manage-users-approvals",
    path: "/manage/users/approvals",
    meta: approvalsoh0twZcmC3Meta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/users/approvals.vue").then(m => m.default || m)
  },
  {
    name: "manage-users",
    path: "/manage/users",
    meta: indexJ8gcVlLFa3Meta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/users/index.vue").then(m => m.default || m)
  },
  {
    name: "manage-zones",
    path: "/manage/zones",
    meta: zonesGLWhgLKxLMMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/manage/zones.vue").then(m => m.default || m)
  },
  {
    name: "policies-copyright",
    path: "/policies/copyright",
    meta: copyrightqYyMdXXjAfMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/policies/copyright.vue").then(m => m.default || m)
  },
  {
    name: "policies-eula",
    path: "/policies/eula",
    meta: eulaidVSJvoPg7Meta || {},
    component: () => import("/opt/render/project/src/.app/pages/policies/eula.vue").then(m => m.default || m)
  },
  {
    name: "policies-privacy",
    path: "/policies/privacy",
    meta: privacyWXXRWDW3IQMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/policies/privacy.vue").then(m => m.default || m)
  },
  {
    name: "policies-support",
    path: "/policies/support",
    meta: supportDh4TcyxSSFMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/policies/support.vue").then(m => m.default || m)
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    meta: unauthorizedN63AC73v5SMeta || {},
    component: () => import("/opt/render/project/src/.app/pages/unauthorized.vue").then(m => m.default || m)
  }
]